module.exports = __webpack_public_path__ + "media/packs/images/notification/attachment-639afcf318fb27712cdc44bb989b468e.svg";